import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-4" }
const _hoisted_2 = { class: "d-none d-md-block mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-4" }, "We just sent a text with a code to your phone.", -1)
const _hoisted_4 = { class: "d-flex flex-column justify-content-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    ref: "modal",
    "has-footer": false,
    "has-header": false,
    "has-toolbar": false,
    title: _ctx.title,
    "is-loading": _ctx.isLoading,
    "loading-text": "Verifying"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _hoisted_3
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        placeholder: "123456",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verificationEntity.verificationCode) = $event)),
        type: "tel",
        maxlength: "6"
      }, null, 512), [
        [_vModelText, _ctx.verificationEntity.verificationCode]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          type: "primary",
          class: "mt-4",
          onClick: _ctx.verify
        }, {
          default: _withCtx(() => [
            _createTextVNode("Verify")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          type: "secondary",
          class: "mt-4",
          onClick: _ctx.toggleClosed
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}